var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeroImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1568,
    height: 823,
    viewBox: "0 0 1568 823",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_105_13627)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1568,
    height: 823,
    fill: "#26253E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M594.5 530H413V542V570V571.5V600V601.5V660V661.5V690V691V691.5H593H594H594.5V542V530ZM443 690H414.5V661.5H443V690ZM473 690H444.5V661.5H473V690ZM503 690H474.5V661.5H503V690ZM533 690H504.5V661.5H533V690ZM563 690H534.5V661.5H563V690ZM593 690H564.5V661.5H593V690ZM593 660V631.5H564.5V660H593ZM563 660V631.5H534.5V660H563ZM533 660V631.5H504.5V660H533ZM503 660V631.5H474.5V660H503ZM443 660V631.5H414.5V660H443ZM443 630H414.5V601.5H443V630ZM473 630H444.5V601.5H473V630ZM503 630H474.5V601.5H503V630ZM533 630H504.5V601.5H533V630ZM563 630H534.5V601.5H563V630ZM593 630H564.5V601.5H593V630ZM593 600V571.5H564.5V600H593ZM563 600V571.5H534.5V600H563ZM533 600V571.5H504.5V600H533ZM503 600V571.5H474.5V600H503ZM473 600V571.5H444.5V600H473ZM443 600V571.5H414.5V600H443ZM443 570H414.5V542H443V570ZM473 570H444.5V542H473V570ZM503 570H474.5V542H503V570ZM533 570H504.5V542H533V570ZM563 570H534.5V542H563V570ZM593 570H564.5V542H593V570Z",
    fill: "#FFCFCD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M250 2V135H249V2H250Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 249.5,
    cy: 141.5,
    r: 6.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M426.891 834V730.15H426.11V834H426.891Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5.07534,
    transform: "matrix(1 0 0 -1 426.5 725.075)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M791 823V760H790V823H791Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 6.5,
    transform: "matrix(1 0 0 -1 790.5 753.5)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1290 823V703H1289V823H1290Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 6.5,
    transform: "matrix(1 0 0 -1 1289.5 696.5)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M731 0V87H730V0H731Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 730.5,
    cy: 93.5,
    r: 6.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1319 0V87H1318V0H1319Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1318.5,
    cy: 93.5,
    r: 6.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M838 0V284H837V0H838Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 837.5,
    cy: 290.5,
    r: 6.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 411H120V412H0V411Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126.5,
    cy: 411.5,
    r: 6.5,
    transform: "rotate(-90 126.5 411.5)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1568 364L1303 364V365L1568 365V364Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 6.5,
    transform: "matrix(0 -1 -1 0 1296.5 364.5)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1085.5 179.5H1240.5V187.996H1085.5V179.5ZM1084 189.496V327.5V329H1085.5H1240.5H1242V327.5V179.5V178H1240.5H1085.5H1084V179.5V187.996H1084V189.496H1084ZM1085.5 189.496H1240.5V327.5H1085.5V189.496ZM1114.5 211.5H1101.5V224.5H1114.5V211.5ZM1101.5 210H1100V211.5V224.5V226H1101.5H1114.5H1116V224.5V211.5V210H1114.5H1101.5ZM1139.5 211.5H1220.5V224.5H1139.5V211.5ZM1138 210H1139.5H1220.5H1222V211.5V224.5V226H1220.5H1139.5H1138V224.5V211.5V210ZM1100 238H1116V254H1100V238ZM1222 238H1138V254H1222V238ZM1114.5 267.5H1101.5V280.5H1114.5V267.5ZM1101.5 266H1100V267.5V280.5V282H1101.5H1114.5H1116V280.5V267.5V266H1114.5H1101.5ZM1139.5 267.5H1220.5V280.5H1139.5V267.5ZM1138 266H1139.5H1220.5H1222V267.5V280.5V282H1220.5H1139.5H1138V280.5V267.5V266ZM1100 294H1116V310H1100V294ZM1222 294H1138V310H1222V294Z",
    fill: "#FFCFCD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M228.5 677.5H369.5V701.5H228.5V677.5ZM227 676H228.5H369.5H371V677.5V701.5V703H369.5H228.5H227V701.5V677.5V676ZM236.5 684.5H246.5V694.5H236.5V684.5ZM235 683H236.5H246.5H248V684.5V694.5V696H246.5H236.5H235V694.5V684.5V683ZM257 689H359V690.5H257V689ZM228.5 708.5H369.5V732.5H228.5V708.5ZM227 707H228.5H369.5H371V708.5V732.5V734H369.5H228.5H227V732.5V708.5V707ZM236.5 715.5H246.5V725.5H236.5V715.5ZM235 714H236.5H246.5H248V715.5V725.5V727H246.5H236.5H235V725.5V715.5V714ZM257 720H359V721.5H257V720ZM369.5 739.5H228.5V763.5H369.5V739.5ZM228.5 738H227V739.5V763.5V765H228.5H369.5H371V763.5V739.5V738H369.5H228.5ZM246.5 746.5H236.5V756.5H246.5V746.5ZM236.5 745H235V746.5V756.5V758H236.5H246.5H248V756.5V746.5V745H246.5H236.5ZM359 751H257V752.5H359V751ZM228.5 770.5H369.5V794.5H228.5V770.5ZM227 769H228.5H369.5H371V770.5V794.5V796H369.5H228.5H227V794.5V770.5V769ZM236.5 777.5H246.5V787.5H236.5V777.5ZM235 776H236.5H246.5H248V777.5V787.5V789H246.5H236.5H235V787.5V777.5V776ZM257 782H359V783.5H257V782Z",
    fill: "#FFCFCD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.5 32.5H161.5V252.5H42.5V32.5ZM41 31H42.5H161.5H163V32.5V252.5V254H161.5H42.5H41V252.5V32.5V31ZM151 44L147.061 47.9393L151.061 51.9393L150 53L146 49L142 53L140.939 51.9393L144.939 47.9393L141 44L142.061 42.9393L146 46.8787L149.939 42.9393L151 44Z",
    fill: "#FFCFCD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 955.75,
    y: 57.75,
    width: 138.5,
    height: 89.5,
    stroke: "#FFCFCD",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 891.75,
    y: 669.75,
    width: 71.5,
    height: 114.5,
    stroke: "#FFCFCD",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1401.11 431.5H1449C1458.11 431.5 1465.5 438.887 1465.5 448C1465.5 457.113 1458.11 464.5 1449 464.5H1401.11C1408.51 462.662 1414 455.972 1414 448C1414 440.028 1408.51 433.338 1401.11 431.5ZM1392.89 431.5H1392C1382.89 431.5 1375.5 438.887 1375.5 448C1375.5 457.113 1382.89 464.5 1392 464.5H1392.89C1385.49 462.662 1380 455.972 1380 448C1380 440.028 1385.49 433.338 1392.89 431.5ZM1374 448C1374 438.059 1382.06 430 1392 430H1449C1458.94 430 1467 438.059 1467 448C1467 457.941 1458.94 466 1449 466H1392C1382.06 466 1374 457.941 1374 448Z",
    fill: "#FFCFCD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1489 508.5H1368C1357.78 508.5 1349.5 516.783 1349.5 527V727C1349.5 737.217 1357.78 745.5 1368 745.5H1489C1499.22 745.5 1507.5 737.217 1507.5 727V527C1507.5 516.783 1499.22 508.5 1489 508.5ZM1368 507C1356.95 507 1348 515.954 1348 527V727C1348 738.046 1356.95 747 1368 747H1489C1500.05 747 1509 738.046 1509 727V527C1509 515.954 1500.05 507 1489 507H1368ZM1486.49 529.18L1479.1 521.792L1480.16 520.732L1487.55 528.12L1494.94 520.732L1496 521.792L1488.61 529.18L1495.37 535.939L1494.31 537L1487.55 530.241L1480.79 537L1479.73 535.939L1486.49 529.18ZM1422 578H1360V582H1422V578ZM1364 601.5H1456C1457.38 601.5 1458.5 602.619 1458.5 604V620C1458.5 621.381 1457.38 622.5 1456 622.5H1364C1362.62 622.5 1361.5 621.381 1361.5 620V604C1361.5 602.619 1362.62 601.5 1364 601.5ZM1360 604C1360 601.791 1361.79 600 1364 600H1456C1458.21 600 1460 601.791 1460 604V620C1460 622.209 1458.21 624 1456 624H1364C1361.79 624 1360 622.209 1360 620V604ZM1439 635.5H1364C1362.62 635.5 1361.5 636.619 1361.5 638V654C1361.5 655.381 1362.62 656.5 1364 656.5H1439C1440.38 656.5 1441.5 655.381 1441.5 654V638C1441.5 636.619 1440.38 635.5 1439 635.5ZM1364 634C1361.79 634 1360 635.791 1360 638V654C1360 656.209 1361.79 658 1364 658H1439C1441.21 658 1443 656.209 1443 654V638C1443 635.791 1441.21 634 1439 634H1364ZM1445 674.5H1485C1490.8 674.5 1495.5 679.201 1495.5 685C1495.5 690.799 1490.8 695.5 1485 695.5H1445C1439.2 695.5 1434.5 690.799 1434.5 685C1434.5 679.201 1439.2 674.5 1445 674.5ZM1433 685C1433 678.373 1438.37 673 1445 673H1485C1491.63 673 1497 678.373 1497 685C1497 691.627 1491.63 697 1485 697H1445C1438.37 697 1433 691.627 1433 685ZM1359 685C1359 678.373 1364.37 673 1371 673H1411C1417.63 673 1423 678.373 1423 685C1423 691.627 1417.63 697 1411 697H1371C1364.37 697 1359 691.627 1359 685Z",
    fill: "#FFCFCD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M299 178H531V200V305C531 313.284 524.284 320 516 320H314C305.716 320 299 313.284 299 305V200V178ZM300.5 305V200H529.5V305C529.5 312.456 523.456 318.5 516 318.5H314C306.544 318.5 300.5 312.456 300.5 305ZM333 224H508C508.552 224 509 224.448 509 225V237C509 237.552 508.552 238 508 238H333C332.448 238 332 237.552 332 237V225C332 224.448 332.448 224 333 224ZM331 225C331 223.895 331.895 223 333 223H508C509.105 223 510 223.895 510 225V237C510 238.105 509.105 239 508 239H333C331.895 239 331 238.105 331 237V225ZM319 247H508C508.552 247 509 247.448 509 248V260C509 260.552 508.552 261 508 261H319C318.448 261 318 260.552 318 260V248C318 247.448 318.448 247 319 247ZM317 248C317 246.895 317.895 246 319 246H508C509.105 246 510 246.895 510 248V260C510 261.105 509.105 262 508 262H319C317.895 262 317 261.105 317 260V248ZM418 281.5C418 278.462 420.462 276 423.5 276H440.5C443.538 276 446 278.462 446 281.5C446 284.538 443.538 287 440.5 287H423.5C420.462 287 418 284.538 418 281.5ZM510 272H456V273H510V272ZM456 276H510V277H456V276ZM510 281H456V282H510V281ZM456 285H510V286H456V285Z",
    fill: "#FFCFCD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M681.5 38.5H471.5V137H681.5V38.5ZM470 38.5V137V137.5V138V139H470.033C470.547 146.818 477.052 153 485 153H668C675.948 153 682.453 146.818 682.967 139H683V138V137.5V137V38.5V37H681.5H471.5H470V38.5ZM514.5 74.5C514.5 80.5751 509.575 85.5 503.5 85.5C497.425 85.5 492.5 80.5751 492.5 74.5C492.5 68.4249 497.425 63.5 503.5 63.5C509.575 63.5 514.5 68.4249 514.5 74.5ZM516 74.5C516 81.4036 510.404 87 503.5 87C496.596 87 491 81.4036 491 74.5C491 67.5964 496.596 62 503.5 62C510.404 62 516 67.5964 516 74.5ZM517 109.5C517 110.328 516.328 111 515.5 111C514.672 111 514 110.328 514 109.5C514 108.672 514.672 108 515.5 108C516.328 108 517 108.672 517 109.5ZM518 109.5C518 110.881 516.881 112 515.5 112C514.119 112 513 110.881 513 109.5C513 108.119 514.119 107 515.5 107C516.881 107 518 108.119 518 109.5ZM493.5 111C494.328 111 495 110.328 495 109.5C495 108.672 494.328 108 493.5 108C492.672 108 492 108.672 492 109.5C492 110.328 492.672 111 493.5 111ZM493.5 112C494.881 112 496 110.881 496 109.5C496 108.119 494.881 107 493.5 107C492.119 107 491 108.119 491 109.5C491 110.881 492.119 112 493.5 112ZM504.5 112C505.881 112 507 110.881 507 109.5C507 108.119 505.881 107 504.5 107C503.119 107 502 108.119 502 109.5C502 110.881 503.119 112 504.5 112ZM659 63H568V74H659V63ZM568 62H567V63V74V75H568H659H660V74V63V62H659H568ZM568 81H659V92H568V81ZM567 80H568H659H660V81V92V93H659H568H567V92V81V80ZM631 105H660V113H631V105Z",
    fill: "#FFCFCD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1122.5 450.5H1274C1281.46 450.5 1287.5 456.544 1287.5 464V624C1287.5 631.456 1281.46 637.5 1274 637.5H1122.5V450.5ZM1121 449H1122.5H1274C1282.28 449 1289 455.716 1289 464V624C1289 632.284 1282.28 639 1274 639H1122.5H1121V637.5V450.5V449ZM1183 473H1142V475H1183V473ZM1195 557H1154V559H1195V557ZM1228 557H1269V559H1228V557ZM1146 487H1206C1207.66 487 1209 488.343 1209 490V507C1209 508.657 1207.66 510 1206 510H1146C1144.34 510 1143 508.657 1143 507V490C1143 488.343 1144.34 487 1146 487ZM1142 490C1142 487.791 1143.79 486 1146 486H1206C1208.21 486 1210 487.791 1210 490V507C1210 509.209 1208.21 511 1206 511H1146C1143.79 511 1142 509.209 1142 507V490ZM1236 520H1146C1144.34 520 1143 521.343 1143 523V540C1143 541.657 1144.34 543 1146 543H1236C1237.66 543 1239 541.657 1239 540V523C1239 521.343 1237.66 520 1236 520ZM1146 519C1143.79 519 1142 520.791 1142 523V540C1142 542.209 1143.79 544 1146 544H1236C1238.21 544 1240 542.209 1240 540V523C1240 520.791 1238.21 519 1236 519H1146ZM1154.5 579C1147.6 579 1142 584.596 1142 591.5C1142 598.404 1147.6 604 1154.5 604H1256.5C1263.4 604 1269 598.404 1269 591.5C1269 584.596 1263.4 579 1256.5 579H1154.5ZM1148 555H1142V561H1148V555ZM1142 554H1141V555V561V562H1142H1148H1149V561V555V554H1148H1142Z",
    fill: "#FFCFCD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 462.5V488.5H158.5V476C158.5 468.544 152.456 462.5 145 462.5H3ZM-26 488.5V490V603C-26 611.284 -19.2843 618 -11 618H145C153.284 618 160 611.284 160 603V490H160.003V488.5H160V476C160 467.716 153.284 461 145 461H-11C-19.2843 461 -26 467.716 -26 476V488.5ZM158.5 603V490H-24.5V603C-24.5 610.456 -18.4558 616.5 -11 616.5H145C152.456 616.5 158.5 610.456 158.5 603ZM-9.87868 477L-5.93934 473.061L-7 472L-10.9393 475.939L-14.8787 472L-15.9393 473.061L-12 477L-16 481L-14.9393 482.061L-10.9393 478.061L-6.93934 482.061L-5.87868 481L-9.87868 477ZM80 516.5H1C-0.380713 516.5 -1.5 517.619 -1.5 519V532C-1.5 533.381 -0.380713 534.5 0.999998 534.5H80C81.3807 534.5 82.5 533.381 82.5 532V519C82.5 517.619 81.3807 516.5 80 516.5ZM1 515C-1.20914 515 -3 516.791 -3 519V532C-3 534.209 -1.20914 536 0.999998 536H80C82.2091 536 84 534.209 84 532V519C84 516.791 82.2091 515 80 515H1ZM1 547.5H125C126.381 547.5 127.5 548.619 127.5 550V563C127.5 564.381 126.381 565.5 125 565.5H0.999996C-0.380714 565.5 -1.5 564.381 -1.5 563V550C-1.5 548.619 -0.380713 547.5 1 547.5ZM-3 550C-3 547.791 -1.20914 546 1 546H125C127.209 546 129 547.791 129 550V563C129 565.209 127.209 567 125 567H0.999996C-1.20914 567 -3 565.209 -3 563V550ZM24 586C24 585.448 24.4477 585 25 585H127C127.552 585 128 585.448 128 586C128 586.552 127.552 587 127 587H25C24.4477 587 24 586.552 24 586ZM5.5 581.5H14.5V590.5H5.5V581.5ZM4 580H5.5H14.5H16V581.5V590.5V592H14.5H5.5H4V590.5V581.5V580Z",
    fill: "#FFCFCD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1429.75,
    y: 209.75,
    width: 73.5,
    height: 73.5,
    stroke: "#FFCFCD",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M999 776H1063V840H999V776ZM1038.89 803.903V791.889H1046.89V823.889H1038.89V811.903H1014.89V803.903H1038.89Z",
    fill: "#FFCFCD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 919.942,
    y: 391.595,
    width: 40.4638,
    height: 40.4638,
    rx: 3.51289,
    stroke: "#FFCFCD",
    strokeWidth: 0.841989
  }), /*#__PURE__*/React.createElement("rect", {
    x: 969.115,
    y: 391.595,
    width: 40.4638,
    height: 40.4638,
    rx: 3.51289,
    stroke: "#FFCFCD",
    strokeWidth: 0.841989
  }), /*#__PURE__*/React.createElement("rect", {
    x: 969.115,
    y: 342.421,
    width: 40.4638,
    height: 40.4638,
    rx: 3.51289,
    stroke: "#FFCFCD",
    strokeWidth: 0.841989
  }), /*#__PURE__*/React.createElement("rect", {
    x: 919.942,
    y: 440.769,
    width: 40.4638,
    height: 40.4638,
    rx: 3.51289,
    stroke: "#FFCFCD",
    strokeWidth: 0.841989
  }), /*#__PURE__*/React.createElement("rect", {
    x: 870.768,
    y: 440.769,
    width: 40.4638,
    height: 40.4638,
    rx: 3.51289,
    stroke: "#FFCFCD",
    strokeWidth: 0.841989
  }), /*#__PURE__*/React.createElement("rect", {
    x: 821.594,
    y: 489.941,
    width: 40.4638,
    height: 40.4638,
    rx: 3.51289,
    stroke: "#FFCFCD",
    strokeWidth: 0.841989
  }), /*#__PURE__*/React.createElement("rect", {
    x: 821.594,
    y: 440.769,
    width: 40.4638,
    height: 40.4638,
    rx: 3.51289,
    stroke: "#FFCFCD",
    strokeWidth: 0.841989
  }), /*#__PURE__*/React.createElement("rect", {
    x: 870.768,
    y: 539.114,
    width: 40.4638,
    height: 40.4638,
    rx: 3.51289,
    stroke: "#FFCFCD",
    strokeWidth: 0.841989
  }), /*#__PURE__*/React.createElement("rect", {
    x: 772.421,
    y: 489.941,
    width: 40.4638,
    height: 40.4638,
    rx: 3.51289,
    stroke: "#FFCFCD",
    strokeWidth: 0.841989
  }), /*#__PURE__*/React.createElement("rect", {
    x: 870.768,
    y: 489.941,
    width: 40.4638,
    height: 40.4638,
    rx: 3.51289,
    fill: "#FFCFCD",
    stroke: "#FFCFCD",
    strokeWidth: 0.841989
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_105_13627)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M911.653 391.416H870.347V432.722H911.653V391.416Z",
    fill: "#FFCFCD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M896.091 401.67V409.424H880.602V414.587H896.091V422.323H901.254V401.67H896.091Z",
    fill: "#26253E"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 821.594,
    y: 539.114,
    width: 40.4638,
    height: 40.4638,
    rx: 3.51289,
    stroke: "#FFCFCD",
    strokeWidth: 0.841989
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_105_13627"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1568,
    height: 823,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_105_13627"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 870.347,
    y: 391.416,
    width: 41.3058,
    height: 41.3058,
    rx: 3.93388,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroImage);
export default __webpack_public_path__ + "static/media/HeroImage.756e4de284c2159e34b7aca6bd0e2d49.svg";
export { ForwardRef as ReactComponent };